"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Audio;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

function Audio(props) {
  var size = props.size,
      other = (0, _objectWithoutProperties2.default)(props, ["size"]);
  return _react.default.createElement("svg", (0, _extends2.default)({
    height: size,
    width: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 16"
  }, other), _react.default.createElement("path", {
    d: "M-3.53,2.95A14.11,14.11,0,0,0-4.9,1.39,14.18,14.18,0,0,0-6.45,0,2.5,2.5,0,0,0-7.87-.63h-7.75A1.25,1.25,0,0,0-16.87.62v13.5a1.25,1.25,0,0,0,1.25,1.25h11.5a1.25,1.25,0,0,0,1.25-1.25V4.37a2.49,2.49,0,0,0-.66-1.42h0ZM-5.6,2.1A13.63,13.63,0,0,1-4.47,3.37H-6.88V1A13.53,13.53,0,0,1-5.61,2.1h0Zm1.73,12a0.25,0.25,0,0,1-.25.25h-11.5a0.25,0.25,0,0,1-.25-0.25V0.62A0.25,0.25,0,0,1-15.62.37h7.75v3.5a0.5,0.5,0,0,0,.5.5h3.5v9.75Z",
    transform: "translate(16.88 0.63)"
  }), _react.default.createElement("path", {
    d: "M-6.06,5.48a0.5,0.5,0,0,0-.41-0.1l-5,1a0.5,0.5,0,0,0-.4.49v3.7a2.52,2.52,0,0,0-1-.2,1.8,1.8,0,0,0-2,1.5,1.8,1.8,0,0,0,2,1.5,1.81,1.81,0,0,0,2-1.5V8.28l4-.8V9.57a2.52,2.52,0,0,0-1-.2,1.8,1.8,0,0,0-2,1.5,1.8,1.8,0,0,0,2,1.5,1.81,1.81,0,0,0,2-1.5v-5a0.5,0.5,0,0,0-.18-0.39h0Z",
    transform: "translate(16.88 0.63)"
  }));
}

Audio.propTypes = {
  size: _react.PropTypes.number
};
module.exports = exports.default;